import { combineReducers } from "redux";
import banksReducer from "./banks/reducer";
import mediaServiceReducer from "./mediaService/reducer";
import selectionsReducer from "./selections/reducer";

export default combineReducers({
    banks: banksReducer,
    mediaService: mediaServiceReducer,
    selections: selectionsReducer,
});